import React, { useState } from 'react'

import { Button, CardContainer, Div } from '@driftt/tide-core'
import { tracking } from '@driftt/traffic-control'

import { fetchSalesSeatUsageCSV } from 'api/report/salesUsageData'
import withQueryConfig from 'hocs/withQueryConfig'
import useNotifications from 'hooks/useNotifications'
import { downloadCSVInUI } from 'utils/csv'

import './styles.css'

const useDownloadSalesSeatUsageCSV = (
  csvType,
  queryConfig
): [() => void, boolean] => {
  const notifications = useNotifications()
  const [downloading, setDownloading] = useState(false)
  const handleExportToCSV = async (csvType) => {
    const startDate = queryConfig.startDate
    const endDate = queryConfig.endDate

    try {
      const csvData = await fetchSalesSeatUsageCSV(
        {
          startDate,
          endDate,
          metric: '',
        },
        csvType
      )

      downloadCSVInUI(
        csvData,
        `Sales Seat Tool Usage Data: [${startDate} — ${endDate}]`
      )
      tracking.trackEvent('Sales CSV Downloaded', { csvType })
    } catch (err) {
      notifications.error('There was a error while trying to create the CSV.')
    }
  }

  const download = () => {
    setDownloading(true)
    handleExportToCSV(csvType)
      .catch(() =>
        notifications.error('There was a error while trying to create the CSV.')
      )
      .finally(() => setDownloading(false))
  }
  return [download, downloading]
}

const SalesUsageReport = ({ queryConfig }) => {
  const [downloadAccountInfluencedCSV, downloadingAccountInfluencedCSV] =
    useDownloadSalesSeatUsageCSV('accountsInfluenced', queryConfig)
  const [downloadToolUsageCSV, downloadingToolUsageCSV] =
    useDownloadSalesSeatUsageCSV('toolUsage', queryConfig)

  return (
    <>
      <Div className="sales-usage-cards">
        <CardContainer header="Which accounts has my team influenced?">
          <div className="sales-text">
            <p className="tide-paragraph tide-paragraph-1">
              Select a time range to export a CSV of accounts influenced by your
              team’s use of Drift Video and Prospector.
            </p>
          </div>
          <Button
            loading={downloadingAccountInfluencedCSV}
            iconAlignment="left"
            className="sales-seat-csv-export-button"
            type="tertiary"
            onClick={downloadAccountInfluencedCSV}
          >
            Export CSV
          </Button>
        </CardContainer>
        <CardContainer header="How is my team utilizing Drift’s sales tools?">
          <div className="sales-text">
            <p className="tide-paragraph tide-paragraph-1">
              Select a time range to export a CSV of your team’s sales seat
              analytics, including actions taken in Prospector and videos
              created using Drift Video.
            </p>
          </div>
          <Button
            loading={downloadingToolUsageCSV}
            className="sales-seat-csv-export-button"
            type="tertiary"
            onClick={downloadToolUsageCSV}
          >
            Export CSV
          </Button>
        </CardContainer>
      </Div>
    </>
  )
}

export default withQueryConfig(SalesUsageReport)
